import { useFormikContext } from "formik";
import { Button } from "../../common/Button";
import React, { useContext } from "react";
import PropTypes from "prop-types";
import { createUseStyles } from "react-jss";
import jssVariables from "../../../jss_setup";
import _ from "lodash";
import { TranslationContext } from "../../../umbilical_tools";

export const SubmitGuestBtn = ({ id }) => {
  const { t } = useContext(TranslationContext);
  const { submitForm } = useFormikContext();
  return (
    <Button
      id={id}
      text={t("next")}
      bold={true}
      size="large"
      onClick={() => {
        submitForm();
      }}
    />
  );
};
SubmitGuestBtn.defaultProps = {
  id: "",
};
SubmitGuestBtn.propTypes = {
  id: PropTypes.string,
};

export const ActionBtnsLoader = () => {
  return (
    <React.Fragment>
      <Button size="large" ghost={true} />
      <Button size="large" ghost={true} />
    </React.Fragment>
  );
};

export const BackBtn = ({ backBtnProps: { step, t, prevStep } }) => {
  return (
    <Button
      text={step > 0 ? t("back") : t("cancel")}
      bold={true}
      size="large"
      onClick={prevStep}
    />
  );
};
BackBtn.defaultProps = {
  backBtnProps: {
    step: 0,
    t: () => {},
    prevStep: () => {},
  },
};
BackBtn.propTypes = {
  backBtnProps: PropTypes.shape({
    step: PropTypes.number,
    t: PropTypes.func,
    prevStep: PropTypes.func,
  }),
};

const styles = createUseStyles({
  CustomerRemarks: (props) => ({
    display: "grid",
    gridTemplateColumns: "1fr",
    gridGap: jssVariables.normal_gap,
    boxShadow: jssVariables.shadows.normalShadow,
    borderRadius: jssVariables.half_gap,
    padding: jssVariables.normal_gap,
    ..._.get(props, "customStyles.CustomerRemarks", {}),
  }),
  header: (props) => ({
    display: "grid",
    gridTemplateColumns: "max-content 1fr",
    gridGap: jssVariables.normal_gap,
    alignItems: "center",
    fontSize: "x-large",
    background: jssVariables.colors.base_color,
    borderRadius: jssVariables.half_gap,
    padding: [jssVariables.normal_gap, jssVariables.double_gap],
    color: "white",
    fontWeight: 500,
    ..._.get(props, "customStyles.header", {}),
  }),
  textarea: (props) => ({
    resize: "none",
    borderColor: jssVariables.colors.border,
    padding: jssVariables.normal_gap,
    ..._.get(props, "customStyles.textarea", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {},
  [`@media ${jssVariables.media.bigscreen}`]: {},
});
export const CustomerRemarks = ({ bookRemarks, setBookRemarks, id }) => {
  const classes = styles({});

  const { t } = useContext(TranslationContext);

  return (
    <div className={classes.CustomerRemarks}>
      <div className={classes.header}>{t("bookingRemarks")}</div>
      <textarea
        id={id}
        placeholder={`${t("bookingRemarks")}...`}
        rows={6}
        className={classes.textarea}
        defaultValue={bookRemarks}
        onBlur={(e) => setBookRemarks(e.target.value)}
      />
    </div>
  );
};
CustomerRemarks.defaultProps = {
  bookRemarks: "",
  id: "",
};
CustomerRemarks.propTypes = {
  bookRemarks: PropTypes.string,
  setBookRemarks: PropTypes.func.isRequired,
  id: PropTypes.string,
};
